import styled from "styled-components";

export const MainFooter = styled.div`
    background-color: #002f47;
    width: 100%;
    bottom: 0;
    display: flex;
    flex-direction: column;
    min-height:10vh; 
    
`
export const Row1 = styled.div`
    padding-bottom: 25px;
`
export const FooterContainer = styled.div`
    min-height: fit-content;
`

export const FooterRow = styled.div`

`

export const FooterColumn = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3rem;

`

export const CreateAnnotation = styled.p`
    color: white;
    font-size: 13px;
    margin-bottom: 1rem;
    letter-spacing: 2px;

`
export const IconHolder = styled.h1`

`

